import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import i18next from 'i18next';
import logo from '@/Fi16100/Images/16100_fi.webp';
import {router} from '@inertiajs/react'
import './CookieConsent.css';

function CookieConsent(props) {
	const t = i18next.t;

	async function send(didConsent) {
		props.onHide();

		// Ignore errors so that site can at least be used if something goes wrong.
		try {
			await axios.post(route('fi16100.cookie-consent.store'), {
				accept: didConsent ? '1' : '0'
			});

			if(didConsent)
				router.reload({ only: ['cookieConsent'] })
		}
		catch(error) {
			console.error(error);
		}
	}

	return (
		<Modal id={props.id}
			   className={(props.className ?? '') + ' cookie-consent py-5'}
			   contentClassName="rounded-1 pt-3 pb-2"
			   size="lg"
			   show={props.show}>

			<div className="px-lg-5 py-3">
				<Modal.Header className="d-flex justify-content-center border-0 py-0 mb-4">
					<img src={logo}
						 alt={t('cookieConsent.logoAlt')}
						 className="img-fluid consent-logo"
					/>
				</Modal.Header>

				<Modal.Body className="text-center py-0 mb-4">
					<div className="fs-5 fw-semibold text-center mb-2">
						{ t('cookieConsent.header') }
					</div>

					<div>
						{ t('cookieConsent.text') }
					</div>
				</Modal.Body>

				<Modal.Footer className="border-0 d-block py-0">
					<div className="row">
						<div className="col-12 col-lg-6 mb-2">
							<Button variant="light"
									className="choice-button w-100 rounded-1 border"
									onClick={() => send(false)}>
								{ t('cookieConsent.reject') }
							</Button>
						</div>

						<div className="col-12 col-lg-6 mb-2">
							<Button variant="primary"
									className="choice-button w-100 rounded-1"
									onClick={() => send(true)}>
								{ t('cookieConsent.accept') }
							</Button>
						</div>
					</div>
				</Modal.Footer>
			</div>
		</Modal>
	);
}

CookieConsent.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	show: PropTypes.bool,
	onHide: PropTypes.func
};

export default CookieConsent;
